var _rect, _text, _line, _line2, _text2, _rect2, _text3, _line3, _text4, _line4, _line5, _text5, _text6, _line6, _text7, _text8, _line7, _text9, _text10, _line8, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsVoidCheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 183,
    viewBox: "0 0 650 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 640,
    height: 290,
    rx: 10,
    fill: "#F8F8F8",
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 45,
    fontFamily: "Inter, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#333333"
  }, "YourBank")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 65,
    x2: 620,
    y2: 65,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 125,
    x2: 450,
    y2: 125,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 120,
    fontFamily: "Inter, sans-serif",
    fontSize: 14,
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 95,
    width: 150,
    height: 30,
    rx: 5,
    fill: "#EAEAEA",
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 115,
    fontFamily: "Inter, sans-serif",
    fontSize: 18,
    fill: "#6B7280"
  }, "$")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 170,
    x2: 620,
    y2: 170,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 165,
    fontFamily: "Inter, sans-serif",
    fontSize: 14,
    fill: "#666666"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 220,
    x2: 300,
    y2: 220,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 220,
    x2: 620,
    y2: 220,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 210,
    fontFamily: "Brush Script MT, cursive",
    fontSize: 28,
    fill: "#666666",
    textAnchor: "middle"
  }, "Your Signature")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 270,
    fontFamily: "MICR, sans-serif",
    fontSize: 18,
    fill: "#333333",
    textAnchor: "start"
  }, "\u2446012345678\u2446")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 275,
    x2: 85,
    y2: 325,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 338,
    fontFamily: "Inter, sans-serif",
    fontSize: 15,
    fill: "#666666",
    textAnchor: "middle"
  }, "Routing number")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 270,
    fontFamily: "MICR, sans-serif",
    fontSize: 18,
    fill: "#333333",
    textAnchor: "middle"
  }, "9876543210")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 275,
    x2: 260,
    y2: 325,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 338,
    fontFamily: "Inter, sans-serif",
    fontSize: 15,
    fill: "#666666",
    textAnchor: "middle"
  }, "Account number")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 270,
    fontFamily: "MICR, sans-serif",
    fontSize: 18,
    fill: "#333333",
    textAnchor: "middle"
  }, "\u24470001")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 430,
    y1: 275,
    x2: 430,
    y2: 325,
    stroke: "#D1D5DB",
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 338,
    fontFamily: "Inter, sans-serif",
    fontSize: 15,
    fill: "#666666",
    textAnchor: "middle"
  }, "Check number")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsVoidCheque);
export default __webpack_public_path__ + "static/media/us-void-cheque.0ec07ab4c3669e0411382efb0ff4db37.svg";
export { ForwardRef as ReactComponent };